export default "/images/flag-en.png?7ece6e44a2f6488533def3ff6a990c5d";